import { Typography } from '@mui/material';
import type { Currency, PromotionInput } from '@weft/types';
import React from 'react';
import { PromotionItem } from './PromotionItem';

type PromotionsSectionProps = {
  promotions: PromotionInput[];
  currency: Currency;
};

export const PromotionsSection: React.FC<PromotionsSectionProps> = ({ promotions, currency }) => {
  return (
    <section className="px-2">
      <Typography
        color="#111B1E"
        fontWeight={300}
        fontSize="12px"
        lineHeight="16px"
      >
        Promotions
      </Typography>

      <ul className="mt-4 space-y-8">
        {promotions.map((promotion) => (
          <PromotionItem
            key={promotion.id}
            promotion={promotion}
            currency={currency}
          />
        ))}
      </ul>
    </section>
  );
};